import { useEffect, useMemo, useState } from 'react';

import './styles.css';

// Full-page celebration overlay. Sits below the top game-header so the
// logout panel remains reachable. Supports a single `content` React node
// or an array of nodes that rotate on an interval (used for the
// Champions↔Second-Place cycle shown to instructors).
export default function CelebrationModal({
  content,
  variant = '',
  rotationIntervalMs = 10000,
  onClose
}) {
  const frames = useMemo(() => (Array.isArray(content) ? content : [content]), [content]);
  const variants = useMemo(() => (Array.isArray(variant) ? variant : [variant]), [variant]);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setActiveIndex(0);
  }, [frames.length]);

  useEffect(() => {
    if (frames.length <= 1) return;
    const intervalId = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % frames.length);
    }, rotationIntervalMs);
    return () => clearInterval(intervalId);
  }, [frames.length, rotationIntervalMs]);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  const activeVariant = variants[activeIndex] || variants[0] || '';

  return (
    <div className={`celebration-overlay ${activeVariant}`}>
      <button
        type="button"
        className="celebration-close-button"
        aria-label="Close celebration"
        onClick={onClose}
      >
        ×
      </button>
      <div className="celebration-body" key={activeIndex}>
        {frames[activeIndex]}
      </div>
      {frames.length > 1 && (
        <div className="celebration-rotation-indicator">
          {frames.map((_, i) => (
            <div
              key={i}
              className={`celebration-rotation-dot ${i === activeIndex ? 'active' : ''}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}
